import axiosServices from '@utils/axios';
const backendUrl = import.meta.env.VITE_BACKEND_URL;

export async function fetchAnalysisItems(studyId) {
  const { data } = await axiosServices.get(
    `${backendUrl}/qualitative-studies/${studyId}/analyses/items`,
  );
  return data; // Array of { analysis_item_id, created_at, analysis_lens_type }
}
export async function fetchAnalysisItemDetail(studyId, analysisItemId) {
  const { data } = await axiosServices.get(
    `${backendUrl}/qualitative-studies/${studyId}/analyses/items/${analysisItemId}`,
  );
  return data; // AnalysisItemDetails, including optional results
}
export async function runAnalysisLens(
  studyId,
  analysis_lens_type,
  transcript_ids,
  analysis_level = null,
  custom_prompt = '',
  workspaceId = null,
) {
  // workspace_id required for atomic credit deduction
  const url = `${backendUrl}/qualitative-studies/${studyId}/analyses/lenses/run${workspaceId ? `?workspace_id=${workspaceId}` : ''}`;
  const { data } = await axiosServices.post(url, {
    analysis_lens_type,
    transcript_ids,
    analysis_level,
    custom_prompt,
  });
  return data;
}
export async function deleteAnalysisItem({ studyId, analysisItemId }) {
  const url = `${backendUrl}/qualitative-studies/${studyId}/analyses/items/${analysisItemId}`;
  await axiosServices.delete(url);
}
export async function deleteChatHistoryItem({ chatId }) {
  const url = `${backendUrl}/chat/delete/${chatId}`;
  await axiosServices.delete(url);
}

export async function fetchNextAnalysis(studyId) {
  const { data } = await axiosServices.get(
    `${backendUrl}/qualitative-studies/studies/${studyId}/next_analysis_step`,
  );
  return data;
}
